import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionType, InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from 'helpers/authConfig';
import { isNil } from 'lodash';

export const useBrandWebsiteLinks = () => {
    const getQuerystringToBrandWebsite = () => {
        return "?evar25=ca_shop";
    }

    const getPrivacyLink = () => {
        return `https://www.cadillacanz.com/au-en/privacy${getQuerystringToBrandWebsite()}`;
    }

    const getLearnAboutLYRIQLink = () => {
        return `https://www.cadillacanz.com/au-en/lyriq-electric-suv${getQuerystringToBrandWebsite()}`;
    }

    const getErrorLink = () => {
        return `https://www.cadillacanz.com/error${getQuerystringToBrandWebsite()}`;
    }

    const getNewsLink = () => {
        return `https://www.cadillacanz.com/au-en/news${getQuerystringToBrandWebsite()}`;
    }
    const getRegisterLink = () => {
        return `https://www.cadillacanz.com/au-en/register${getQuerystringToBrandWebsite()}`;
    }
    const getWhyCadillacLink = () => {
        return `https://www.cadillacanz.com/au-en/why-cadillac${getQuerystringToBrandWebsite()}`;
    }
    const getEVLifeLink = () => {
        return `https://www.cadillacanz.com/au-en/ev-life${getQuerystringToBrandWebsite()}`;
    }
    const getContactUsLink = () => {
        return `https://www.cadillacanz.com/au-en/contact-us${getQuerystringToBrandWebsite()}`;
    }

    const getWorldwideLink = () => {
        return `https://www.cadillac.com/worldwide-websites${getQuerystringToBrandWebsite()}`;
    }
    const getCopyRight = () => {
        return `https://www.gm.com/copyright-trademark${getQuerystringToBrandWebsite()}`;
    }
    const getOwnershipServiceLink = () => {
        return `https://www.cadillacanz.com/au-en/ownership-service${getQuerystringToBrandWebsite()}`;
    }
    const getBeIconic = () => {
        return `https://www.cadillacanz.com/au-en/be-iconic-series${getQuerystringToBrandWebsite()}`;
    }

    const getVisitShowRoomLink = () => {
        return `https://www.cadillacanz.com/au-en/visit-a-showroom${getQuerystringToBrandWebsite()}`;
    }

    const getFAQLink = () => {
        return `https://www.cadillacanz.com/au-en/frequently-asked-questions${getQuerystringToBrandWebsite()}`;
    }
    const getOwnershipWarrantLink = () => {
        return `https://www.cadillacanz.com/au-en/ownership-warranty${getQuerystringToBrandWebsite()}`;
    }
    const getOwnershipRoadsideAssistanceLink = () => {
        return `https://www.cadillacanz.com/au-en/ownership-roadside-assistance${getQuerystringToBrandWebsite()}`;
    }

    const getBrandWebsiteHomePageLink = () => {
        return `https://https://www.cadillacanz.com/au-en${getQuerystringToBrandWebsite()}`;
    }

    return {
        getQuerystringToBrandWebsite,
        getPrivacyLink,
        getLearnAboutLYRIQLink,
        getErrorLink,
        getNewsLink,
        getRegisterLink,
        getWhyCadillacLink,
        getEVLifeLink,
        getContactUsLink,
        getWorldwideLink,
        getCopyRight,
        getOwnershipServiceLink,
        getBeIconic,
        getVisitShowRoomLink,
        getFAQLink,
        getOwnershipWarrantLink,
        getOwnershipRoadsideAssistanceLink,
        getBrandWebsiteHomePageLink,
    };
}